<div class="usecases-cards">
	<bp-usecase-card
		*ngFor="let usecaseDto of usecasesCardsDto$ | async"
		[src]="usecaseDto"
		previewMode
	></bp-usecase-card>
</div>

<a mat-flat-button class="promo-flat-button all-usecases-btn" color="primary" routerLink="/usecases"> All Use Cases </a>
